import { render, staticRenderFns } from "./ReportDesktopGroupTaken.vue?vue&type=template&id=88b8982e"
import script from "./ReportDesktopGroupTaken.vue?vue&type=script&lang=js"
export * from "./ReportDesktopGroupTaken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports